import { render, staticRenderFns } from "./UpdatePasswordPage.vue?vue&type=template&id=5029964a&scoped=true"
import script from "./UpdatePasswordPage.vue?vue&type=script&lang=ts"
export * from "./UpdatePasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePasswordPage.vue?vue&type=style&index=0&id=5029964a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029964a",
  null
  
)

export default component.exports